/** Rhythmz — DOM helpers */

export function el<T extends HTMLElement = HTMLElement>(selector: string): T {
  const node = document.querySelector(selector);
  if (!node) throw new Error(`Element not found: ${selector}`);
  return node as T;
}

let toastTimer = 0;
export function toast(msg: string): void {
  let node = document.querySelector<HTMLElement>('.toast');
  if (!node) {
    node = document.createElement('div');
    node.className = 'toast';
    document.body.appendChild(node);
  }
  node.textContent = msg;
  node.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => node!.classList.remove('show'), 2200);
}
